import React from 'react';
import { Anchor } from 'lucide-react';

interface StatProps {
  icon: typeof Anchor;
  label: string;
  value: string;
}

export default function Stat({ icon: Icon, label, value }: StatProps) {
  return (
    <div className="rounded-lg bg-gray-50 dark:bg-gray-800/60 p-2 border border-gray-100 dark:border-gray-800/30">
      <div className="flex items-center gap-1 text-[9px] uppercase tracking-wider text-gray-500 dark:text-gray-400">
        <Icon className="h-2.5 w-2.5 text-gray-400 dark:text-gray-500" /> {label}
      </div>
      <div className="text-xs font-semibold mt-0.5 tabular-nums truncate text-gray-900 dark:text-white">
        {value}
      </div>
    </div>
  );
}
